<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-modal-promo-code-moo"
      data-bs-toggle="modal"
      data-bs-target="#modalPromoCodeMOO"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-hide-modal-promo-code-moo"
      data-bs-dismiss="modal"
      data-bs-target="#modalPromoCodeMOO"
    ></button>
    <div
      class="modal fade"
      id="modalPromoCodeMOO"
      tabindex="-1"
      aria-labelledby="modalPromoCodeMOOLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div
            class="modal-header d-flex justify-content-end"
            style="border: 0"
          >
            <div class="btn-close-modal" data-bs-dismiss="modal">
              <div>&times;</div>
            </div>
          </div>
          <div class="modal-body">
            <h5
              class="modal-title mb-3 text-center"
              id="modalPromoCodeMOOLabel"
            >
              {{ $t('cart.enterPromoCode') }}
            </h5>
            <div class="mb-3">
              <input
                type="text"
                class="form-control"
                id="promoCodeInput"
                v-model="promoCode"
                :placeholder="$t('cart.promoCodePlaceholder')"
                @keyup.enter="applyPromoCode"
                autofocus
              />
            </div>
            <div class="d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-primary"
                @click="applyPromoCode"
                :disabled="!promoCode.trim()"
                style="margin-bottom: 0"
              >
                {{ $t('cart.applyCode') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "ModalPromoCodeMOO",
  data() {
    return {
      promoCode: "",
    };
  },
  methods: {
    cancelPromoCode() {
      this.promoCode = "";
      $(".btn-hide-modal-promo-code-moo").click();
    },
    applyPromoCode() {
      if (this.promoCode.trim()) {
        this.$emit("apply-promo-code", this.promoCode.trim());
        this.promoCode = "";
        $(".btn-hide-modal-promo-code-moo").click();
      }
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 400px;
}
.modal-content {
  border: none;
  border-radius: 16px;
  background: var(--theme-20, #ffffff);
}

.modal-title {
  color: var(--color, #201a1a);
  font-weight: 700;
}

.form-control {
  border: 1px solid var(--theme-40, #dee2e6);
  background: transparent;
  border-radius: 12px;
  padding: 0.75rem 1rem;
}
.form-control:focus {
  border-color: var(--color, #007bff);
  background: transparent;
  box-shadow: 0 0 0 3px var(--theme-40, rgba(0, 123, 255, 0.25));
}
.form-control::placeholder {
  text-align: center !important;
}

.btn-primary {
  width: 100%;
  background-color: var(--color, #007bff) !important;
  color: white !important;
  border: none !important;
  border-radius: 999px;
  padding: 0.7rem 1rem;
  font-weight: 700;
  box-shadow: none !important;
}
.btn-primary:hover {
  box-shadow: none !important;
}
.btn-primary:disabled {
  opacity: 0.5;
}

.btn-close-modal {
  position: absolute;
  background-color: var(--theme-40, #f8f8f8);
  right: 10px;
  top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  opacity: 1;
  cursor: pointer;
  z-index: 999999;
}

.btn-close-modal div {
    font-size: 32px !important;
    font-weight: 700;
    color: var(--color) !important;
    padding-right: 0 !important;
    margin-bottom: 4.5px;
}
</style>
